if (!customElements.get('variant-radios')) {
  class RadioButtonVariation extends HTMLElement {
    constructor() {
      super();
        function getVariantFromRadio() {
          let variantArr = [];
          const radioInputs = document.querySelectorAll(".product_variation input[type='radio']:checked");
          radioInputs.forEach((el) => {
            const variant = { value: el.value, index: el.parentNode.parentNode.dataset.index };
            variantArr.push(variant);
          });
          return variantArr;
        }
      
        function updateHistoryState(variant) {
          if (!history.replaceState || !variant) {
            return;
          }
      
          const protocol = window.location.protocol;
          const host = window.location.host;
          const pathname = window.location.pathname;
      
          const newurl = `${protocol}//${host}${pathname}?variant=${variant.id}`;
          const stateObj = { path: newurl };
      
          window.history.replaceState(stateObj, '', newurl);
        }
      
        const product_variations = document.querySelectorAll(".product_variation");
        const defaultPrice = document.getElementById("default-price");
      
        product_variations.forEach((variation) => {
          const variantNameElement = variation.querySelector(".prouct_variant_name");
      
          const product_radio = variation.querySelectorAll(".prodcut_radio_option");
          product_radio.forEach((input) => {
            input.addEventListener('input', function () {
              const selectedValues = getVariantFromRadio();
              const variants = window.product.variants;
              const found = variants.find(function (variant) {
                return selectedValues.every(function (values) {
                  return variant[values.index] === values.value;
                });
              });
      
              const images = document.querySelectorAll(".beeda_slider_item img");
              if (found.featured_image && images.length > 0) {
                images.forEach((img) => {
                  img.setAttribute("src", found.featured_image.src);
                  img.setAttribute("srcset", found.featured_image.src);
                });
              }
      
              updateHistoryState(found);
              document.querySelector('#variant-id').value = found.id;
      
              if (defaultPrice) {
                const variantPrice = input.parentNode.querySelector(".variant_price");
                if (variantPrice) {
                  defaultPrice.textContent = variantPrice.textContent;
                  defaultPrice.classList.remove("hidden-price");
                } else {
                  defaultPrice.textContent = '';
                  defaultPrice.classList.add("hidden-price");
                }
              }
      
              const variantOptionName = input.parentNode.querySelector(".variant_name").getAttribute("data-variant-name");
              variantNameElement.textContent = variantOptionName;
            });
      
            // Show selected variant option name by default
            if (input.checked) {
              const variantOptionName = input.parentNode.querySelector(".variant_name").getAttribute("data-variant-name");
              variantNameElement.textContent = variantOptionName;
            }
          });
        });
   }
}
customElements.define("variant-radios", RadioButtonVariation);
}


if (!customElements.get('dropdown-variation')) {
    class DropdownVariation extends HTMLElement {
      constructor() {
        super();
  
        function getVariantFromDropdown() {
          let variantArr = [];
          const dropdownSelects = document.querySelectorAll(".product_select");
          dropdownSelects.forEach((select) => {
            const variant = { value: select.value, index: select.dataset.index };
            variantArr.push(variant);
          });
          return variantArr;
        }
      
        function updateHistoryState(variant) {
          if (!history.replaceState || !variant) {
            return;
          }
      
          const protocol = window.location.protocol;
          const host = window.location.host;
          const pathname = window.location.pathname;
      
          const newurl = `${protocol}//${host}${pathname}?variant=${variant.id}`;
          const stateObj = { path: newurl };
      
          window.history.replaceState(stateObj, '', newurl);
        }
      
        const product_variations = document.querySelectorAll(".product_variation");
        const productPriceElement = document.querySelector('.product_singel_price .prodcut-price');
      
        product_variations.forEach((variation) => {
          const variantNameElement = variation.querySelector(".prouct_variant_name");      
          const dropdownSelects = variation.querySelectorAll(".product_select");

          dropdownSelects.forEach((select) => {
            select.addEventListener('change', function () {
              const selectedValues = getVariantFromDropdown();
              const variants = window.product.variants;
              const found = variants.find(function (variant) {
                return selectedValues.every(function (values) {
                  return variant[values.index] === values.value;
                });
              });
      
              const images = document.querySelectorAll(".beeda_slider_item img");
              if (found.featured_image && images.length > 0) {
                images.forEach((img) => {
                  img.setAttribute("src", found.featured_image.src);
                  img.setAttribute("srcset", found.featured_image.src);
                });
              }
      
              updateHistoryState(found);
              document.querySelector('#variant-id').value = found.id;
      
              if (found) {
                const variantOption = select.options[select.selectedIndex];               
                const variantRegularPrice = variantOption.getAttribute("data-variant-regular-price");
                const variantComparePrice = variantOption.getAttribute("data-variant-compare-price");

                if (variantRegularPrice) {
                  productPriceElement.querySelector('.new-price').textContent = variantRegularPrice;
                } 
    
                if (variantComparePrice) {
                  productPriceElement.querySelector('.old-price').textContent = variantComparePrice;
                } 
                
                const variantOptionName = variantOption.getAttribute("data-variant-name");
                variantNameElement.textContent = variantOptionName;
              } 
            });
      
            // Show selected variant option name by default
            const selectedOption = select.options[select.selectedIndex];
            const variantOptionName = selectedOption.getAttribute("data-variant-name");
            variantNameElement.textContent = variantOptionName;
          });
        });
     }
  }
  
  customElements.define("dropdown-variation", DropdownVariation);
}